import { createFeatureSelector, createSelector } from "@ngrx/store";

import { INotificationsState } from "./notifications.state";
import { AppError, AppMessage, NotificationType } from "../../models";


const feature = createFeatureSelector<INotificationsState>('notifications');

const selectNotifications = createSelector(
  feature,
  (state) => state.notifications
);

const selectErrors = createSelector(
  selectNotifications,
  (notifications) => notifications.filter(x => x.notificationType === NotificationType.Error).map(x => x as AppError)
)

const selectMessages = createSelector(
  selectNotifications,
  (notifications) => notifications.filter(x => x.notificationType === NotificationType.Message).map(x => x as AppMessage)
)

const selectShouldShowNotifications = createSelector(feature, (state) => state.shouldShowNotifcations);

const selectTotal = createSelector(feature, (state) => state.notifications.length);


export const NotificationsSelectors = {
  total: selectTotal,
  shouldShowNotifications: selectShouldShowNotifications,
  notifications: selectNotifications,
  messages: selectMessages,
  errors: selectErrors,
}